class Bootstrap {

    /**
     * @since 4.14.10
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.14.10
     * @returns object The initialized map
     */
    init() {

        // Move the modal down?
        $('.modal').appendTo("body");

        // Prevent conflicts with WP media gallery
        $('.modal').on('show.bs.modal', function (e) {

            // Pop up that class when we open the modal
            $('body').addClass('ll5-modal-open');

        }).on('hidden.bs.modal', function (e) {

            // Remove when the modal closes
            $('body').removeClass('ll5-modal-open');

        });

        // Add as class to the body when the mobile nav is open
        $('#site-navigation').on('show.bs.collapse', function (e) {

            // Add a class to the body
            $('body').addClass('mobile-nav-open');

        }).on('hide.bs.collapse', function (e) {

            // Remove that class from the body
            $('body').removeClass('mobile-nav-open');

        });

        // Declare and initialize
        var slideEasing   = 'linear';
        var slideDuration = 250;

        // Prevent standard handling of dropdown
        $('.dropdown .dropdown-menu .dropdown').off('click');

        /**
         * Handle nested dropdown clicks
         *
         * @since 4.81.1
         * @param object e is the event object
         * @return void
         */
        function handleNested(e) {

            // If a toggle wasn't clicked, do nothing
            if (!$(e.target).hasClass('dropdown-toggle'))
                return;

            // Prevent closing
            e.stopPropagation();
            e.preventDefault();

            // If this is a top-level nav item, do nothing more
            if ($(e.target).hasClass('depth-0'))
                return;

            // Declare and initialize
            let dropdown = $(e.target);
            let parent   = dropdown.parent('.dropdown');
            let type     = parent.hasClass('show') ? 'hide' : 'show';
            let uncles   = parent.siblings();
            let cousins  = uncles.find('.dropdown-toggle');
            let target   = $(dropdown.attr('href'));

            // Hide all the cousins if we are showing here
            if ('show' === type)
                cousins.dropdown('hide')
                    .off('click').on('click', '.dropdown', handleNested)
                    .attr('aria-expanded', 'false');

            /*
             * We run the weird on/off here because Bootstrap will rebind the
             * element when we run $.dropdown().
             */
            dropdown.dropdown(type)
                .off('click').on('click', '.dropdown', handleNested);

            // Update the aria rule manually (not sure why it doesn't work)
            dropdown.attr('aria-expanded', 'hide' === type ? 'false' : 'true');

        }

        // Add a sliding animation to nested dropdowns (when showing)
        $('.dropdown.nav-item').on('show.bs.dropdown', function (e) {

            // Declare and initialize
            let target = $($(e.target).attr('href'));
            let depth  = $(e.target).data('depth') || '0';

            // Only do this for the current depth (relative to target)
            if (!$(this).hasClass('depth-' + depth))
                return;

            // That's all, easy right?
            target.stop(true, true).slideDown({
                easing:   slideEasing,
                duration: slideDuration,
            });

        });

        // Add a sliding animation to nested dropdowns (when hiding)
        $('.dropdown.nav-item').on('hide.bs.dropdown', function (e) {

            // Prevent shenanigans
            e.preventDefault();

            // Declare and inintialize
            let dropdown = $(this);
            let target   = $($(e.target).attr('href'));
            let depth    = $(e.target).data('depth') || '0';

            // Only do this for the current depth (relative to target)
            if (!$(this).hasClass('depth-' + depth))
                return;

            // Run the animation
            target.stop(true, true).slideUp({
                easing:   slideEasing,
                duration: slideDuration,
                complete: () => {
                    // Reset the dropdown state
                    dropdown.removeClass('show');
                    target.removeClass('show');
                    dropdown.find('.dropdown-toggle')
                        .removeClass('show')
                        .attr('aria-expanded', 'false');
                }
            });

        });


        // Nested menu dropdown
        $('.dropdown .dropdown-menu').on('click', '.dropdown', handleNested);

        // Close siblings when a collapse occurs
        $('.collapse-close-siblings').on('show.bs.collapse', '.collapse',
            function (e) {
                $(this).closest('.collapse-close-siblings')
                    .find('.collapse.show').collapse('hide');
            }
        );

        // Close the siblings when we click out
        $(document).on('click', function (e) {

            // See if we are in a collapse
            let target   = $(e.target);
            let closest  = target.closest('.collapse-close-siblings');
            let isCloser = target.hasClass('sibling-closer');

            // If there is no collapser (or if this clses), close all of them
            if (!closest.length || isCloser) {

                // See if there are any targets first
                if ($('.close-when-click-out .collapse.show').length)
                    $('.close-when-click-out .collapse.show').collapse('hide');

            }

        });

        // Do not activate the masonry gallery modal for links
        $('.ll5-block-masonry-gallery').on('click', '[data-toggle="modal"]',
            function (e) {

                // Declare and initialize
                let img     = $(e.target);
                let trigger = img.closest('[data-toggle="modal"]');
                let link    = img.closest('a.masonry-link');

                // If there is no link, do nothing
                if (1 > link.length)
                    return;

                // Otherwise, do not trigger modal
                e.stopPropagation();

            }
        );

    }

}

export default Bootstrap;